export type EventPathSlug = "ayac" | "yafrs";

export function getEventSlugFromPathname(pathname: string): EventPathSlug {
  return pathname.includes("/yafrs") ? "yafrs" : "ayac";
}

export function getEventRegisterHref(
  locale: string,
  slug: EventPathSlug = "yafrs"
): string {
  return `/${locale}/${slug}`;
}